export default {
	inject: ['setSuggestValue'],
	props: {
		item: { type: Object, required: true },
	},
	methods: {
		onSelect(item) {
			this.setSuggestValue(item);
		},
	},
};
